import { createBrowserHistory } from 'history'
import appAnalytics from '../analytics'
export const history = createBrowserHistory()

history.listen((location) => {
  appAnalytics.pageview(location)
})

export default history
